"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliteInvitationInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var PoliteInvitationInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PoliteInvitationInit, _super);
    function PoliteInvitationInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '邀请有礼初始化';
        _this.code = '101038';
        _this.desc = '邀请有礼初始化';
        _this.requestParams = new point_1.PoliteInvitationInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PoliteInvitationInit;
}(service_1.BaseService));
exports.PoliteInvitationInit = PoliteInvitationInit;
//# sourceMappingURL=politeInvitationInit.js.map